import { useParams } from 'react-router-dom';
import { query, where } from 'firebase/firestore';
import { Column } from 'react-rainbow-components';
import DateTimeColumn from 'components/DateTimeColumn';
import Button from 'components/Button';
import Plus from 'components/icons/plus';
import Table from 'components/Table';
import usePhoneNumbers from 'data/firestore/phonenumber/useCollection';
import useManagePhoneNumbers from 'data/hooks/useManagePhoneNumbers';
import LanguageColumn from 'pages/Customers/CustomersList/columns/preferredLanguage';
import { CREATE_EDIT_PHONE_NUMBER_DRAWER } from '../../../constants';
import { CellWrapper } from '../columns/styled';
import PhoneColumn from '../columns/phoneNumber';
import {
    StyledCard, EmptyLabel, TableContainer, Header, Title, Description,
    HeaderContent,
} from '../styled';
import PhonePipelineColumn from './columns/pipeline';
import CreateEditPhoneNumberDrawer from './CreateEditPhoneNumberDrawer';
import ActionsColumn from './columns/actions';
import VoiceAgentColumn from './columns/voiceAgent';
import PersonaColumn from './columns/PersonaColumn';
import SmsSenderColumn from './columns/smsSender';

const AgentPhoneNumbers = () => {
    const { agentId = '' } = useParams();
    const { create } = useManagePhoneNumbers({ agentId });

    const { data: phoneNumbers = [], isLoading: isLoadingPhoneNumbers } = usePhoneNumbers({
        listQueryFn: (ref) => query(ref, where('agentId', '==', agentId)),
        disabled: !agentId,
        track: [agentId],
    });

    return (
        <>
            <StyledCard>
                <Header>
                    <HeaderContent>
                        <Title>Sara AI Phone Numbers</Title>
                        <Description>
                            These numbers are used for Sara AI to handle calls
                        </Description>
                    </HeaderContent>
                    <Button
                        variant="outline-brand"
                        size="medium"
                        borderRadius="semi-rounded"
                        onClick={create}
                    >
                        <Plus />
                        Add Number
                    </Button>
                </Header>
                <TableContainer>
                    <Table
                        data={phoneNumbers}
                        keyField="id"
                        isLoading={isLoadingPhoneNumbers}
                    >
                        <Column
                            header="Phone number"
                            field="number"
                            component={PhoneColumn}
                            width={250}
                        />
                        <Column
                            header="Language"
                            field="language"
                            component={LanguageColumn}
                            width={130}
                        />
                        <Column
                            header="Voice Pipeline"
                            field="voicePipelineServer.id"
                            component={PhonePipelineColumn}
                            width={150}
                        />
                        <Column
                            header="Voice Agent"
                            field="voicePipelineServer.params.elevenLabsAgentId"
                            width={200}
                            component={VoiceAgentColumn}
                        />
                        <Column
                            header="AI Persona"
                            field="voicePipelineServer.params.personaId"
                            component={PersonaColumn}
                        />
                        <Column
                            header="SMS Sender"
                            field="isDefaultSmsSender"
                            component={SmsSenderColumn}
                            width={150}
                        />
                        <Column
                            header="Created At"
                            field="createdAt"
                            component={DateTimeColumn}
                            emptyLabel={(
                                <CellWrapper>
                                    <EmptyLabel>-</EmptyLabel>
                                </CellWrapper>
                            )}
                            width={200}
                        />
                        <Column
                            header="Actions"
                            component={ActionsColumn}
                            defaultWidth={100}
                        />
                    </Table>
                </TableContainer>
            </StyledCard>
            <CreateEditPhoneNumberDrawer modalId={CREATE_EDIT_PHONE_NUMBER_DRAWER} />
        </>
    );
};

export default AgentPhoneNumbers;
